import { createAction } from "@reduxjs/toolkit";
import type { UserVM } from "@shared-kernel/application/ports/shared/shared-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const retrieveUserProfile = createApiThunk<UserVM, void>(
  "users/retrieveUserProfile",
  async (_: void, { extra: { sharedRepository } }) => {
    return sharedRepository!.profile();
  },
);

export const resetRetrieveUserProfile = createAction("users/resetRetrieveUserProfile");
